import React from 'react';
import glamorous from 'glamorous';

import MdCheck from 'react-icons/lib/md/check';
import MdStar from 'react-icons/lib/md/star';

import theme from '../../../../styles/theme';

const uniqueBy = (a, cond) => a.filter((e, i) => a.findIndex(e2 => cond(e, e2)) === i);

const Container = glamorous.div(props => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 72,
  fontSize: 12,

  borderBottom: props.hasBorder ? `1px solid ${theme.default.lightest}` : undefined,
}));

const AttributesList = glamorous.div({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: 16,
  marginBottom: 16,
  paddingLeft: 24,
  listStyle: 'none',
});

const AttributesListItem = glamorous.div(props => ({
  position: 'relative',
  width: '50%',
  lineHeight: '2em',
  paddingLeft: 4,
  paddingRight: 20,
  color: theme.primary.base,

  '&:first-child': {
    width: props.shouldRenderTitle ? '100%' : undefined,
    paddingRight: props.shouldRenderTitle ? 120 : undefined,
  },

  '&:nth-child(2)': {
    width: props.shouldRenderTitle ? '100%' : undefined,
    paddingRight: props.shouldRenderTitle ? 120 : undefined,
  },

  '&:nth-child(even)': {
    paddingRight: 4,
  },
}));

const AttributesListItemIcon = glamorous.div({
  position: 'absolute',
  left: -16,
  display: 'flex',
  alignItems: 'center',
  height: 24,
});

const TitleBlock = glamorous.div(props => ({
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  right: 16,
  top: 16,
  paddingLeft: 12,
  paddingRight: 12,

  backgroundColor: props.isStarred ? theme.accent.base : theme.primary.base,

  color: '#fff',
  fontWeight: 'bold',
  lineHeight: '2em',
}));

const CuratedTitle = glamorous.div({
  position: 'relative',
});

const LeftIcon = glamorous.div({
  position: 'absolute',
  left: -24,
  color: theme.accent.base,
});


const CuratedInfoBlock = props => {
  const { tgClientData } = props.ticket;

  let orderedAttributes = tgClientData.attributes
    // .filter(attr => !!attr.Value)
    .sort((a, b) => {
      if (a.Name.length === b.Name.length) return 0;
      return a.Name.length > b.Name.length ? 1 : -1;
    });

  orderedAttributes = uniqueBy(
    orderedAttributes,
    (attr1, attr2) => attr1.Name === attr2.Name
  );

  const shouldRenderTitle = !!tgClientData.recommendationMessage;
  const shouldRenderStar = shouldRenderTitle && tgClientData.recommendationMessage.toLowerCase().indexOf('tara') > -1;

  if (!orderedAttributes.length) {
    return null;
  }

  return (
    <Container hasBorder={props.hasBorder} className="CuratedInfoBlock">
      <AttributesList>
        {orderedAttributes.map(attr => (
          <AttributesListItem key={attr.Name} shouldRenderTitle={shouldRenderTitle}>
            <AttributesListItemIcon>
              <MdCheck size={16} />
            </AttributesListItemIcon>

            {attr.Name}
          </AttributesListItem>
        ))}
      </AttributesList>

      {shouldRenderTitle && (
        <TitleBlock isStarred={shouldRenderStar}>
          {shouldRenderStar && (
            <LeftIcon><MdStar size={56} /></LeftIcon>
          )}

          <CuratedTitle>
            {tgClientData.recommendationMessage}
          </CuratedTitle>
        </TitleBlock>
      )}
    </Container>
  );
};

export default CuratedInfoBlock;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/Sidebar/CuratedInfoBlock.js